















































































import { Vue, Component, Prop } from "vue-property-decorator";
import _ from "@/boot/lodash";

@Component({
  components: {
    "brand-logo": () => import("@/components/app/global/brand/logo.vue")
  }
})
export default class BrandSupportDepartmentRowItem extends Vue {
  // Props

  @Prop({ default: null })
  public supportDepartment!: any;

  @Prop({ required: true })
  public isLoading!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: false })
  public isProcessing!: boolean;

  // Computed

  public get showSkeletons() {
    return _.isNull(this.supportDepartment);
  }

  public get isAssigned() {
    return !_.isNull(this.supportDepartment.department);
  }

  public get brand() {
    return _.get(this.supportDepartment, "brand");
  }

  public get brandName() {
    return _.get(this.supportDepartment, "brand.name", "");
  }

  public get isBrandDefault() {
    return this.supportDepartment.department?.default || false;
  }

  public get mailboxConfigured() {
    const mailbox = _.get(this.supportDepartment, "department.username", "");
    if (!mailbox) return this.isAssigned ? this.$t("_.not_configured") : "--";

    const hostName = `${this.supportDepartment.brand.code || ""}.${
      process.env.VUE_APP_UPMIND_APP_DOMAIN
    }`;
    return `${mailbox}@${hostName}`;
  }
}
